import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import MenuItem from "@material-ui/core/MenuItem";
import {
  addFieldData,
  handleContinueFooter,
  setItemBreadcrumbs,
  setMessageWithCode,
  setReturnedValue,
  showFooterContinue
} from "../actions";
import {
  List as MaterialList,
  ListItem,
  ListItemText
} from "@material-ui/core";
import PriorityCode from "./PriorityCode";
import { getProtocol } from "../utils/protocole";
import VideocamIcon from "@material-ui/icons/Videocam";
import AlertDialog from "./AlertDialog";
import { translator } from "../utils/i18n";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedItem: undefined,
      target: undefined,
      showBtnContinue: props.step.needContinue
    };
    if (props.step.needContinue) {
      this.props.showFooterContinue(true);
    }
  }

  componentDidMount() {
    this.props.step.data.fetchSource &&
      this.props.fetchData(this.props.step.data.fetchSource);
    if (this.props.step.needContinue) {
      this.props.showFooterContinue({
        isShow: true,
        handler: this.handleSubmit,
        disabled: !this.state.selectedItem
      });
      this.props.handleContinueFooter(this.handleSubmit);
    }
  }

  componentWillUnmount() {
    const dataKey = this.props.step.data.keyValue;
    this.props.resetData(dataKey);
    if (this.props.step.needContinue) {
      this.props.showFooterContinue({
        isShow: false,
        handler: undefined,
        disabled: undefined
      });
      this.props.handleContinueFooter(null);
      this.setState({ showBtnContinue: false });
    }
  }

  getData = () => {
    const dataKey = this.props.step.data.keyValue;
    if (this.props.dataSource && this.props.dataSource[dataKey]) {
      let data = this.props.dataSource[dataKey];
      if (data && this.props.step.data.formatSource) {
        data = this.props.step.data.formatSource(data);
      }
      if (data.length === 1 && !this.state.selectedItem) {
        this.setState({ selectedItem: data[0] });
      }
      return data;
    }
    return null;
  };

  getRenderSelect = data => {
    if (data) {
      return data.map(item => {
        return (
          <MenuItem
            key={item.key}
            value={item.value}
            datavalue={item.dataValue}
            datalabel={item.label}
          >
            {item.label}
          </MenuItem>
        );
      });
    }
    return [];
  };

  getRenderItem = data => {
    const { selectedItem } = this.state;

    if (data) {
      return data.map(item => {
        return (
          <ListItem
            button
            key={item.key}
            datalabel={item.label}
            datavalue={item.value}
            onClick={e => this.handleClick(e, item)}
            selected={selectedItem ? selectedItem.key === item.key : false}
            className={
              selectedItem && data.length == 1 ? "noBackSelection" : ""
            }
          >
            <ListItemText className="text" primary={item.label} />
          </ListItem>
        );
      });
    }
    return [];
  };

  getRenderItemPraticien = data => {
    const { selectedItem } = this.state;
    if (data) {
      return data.map(item => {
        if (item.value === 0) {
          return (
            <div key={item.key}>
              <ListItem
                button
                datalabel={item.label}
                datavalue={item.value}
                onClick={e => this.handleClick(e, item)}
                selected={selectedItem ? selectedItem.key === item.key : false}
                className={
                  selectedItem && data.length === 1 ? "noBackSelection" : ""
                }
              >
                <img
                  src="images/calendar-bolt.svg"
                  style={{ marginRight: "5px" }}
                />
                <ListItemText
                  primary={
                    <span style={{ fontWeight: 500 }}>{item.label}</span>
                  }
                />
              </ListItem>
              <ListItem style={{ fontSize: "small", color: "grey" }}>
                Ou sélectionnez un praticien :
              </ListItem>
            </div>
          );
        } else {
          return (
            <ListItem
              button
              key={item.key}
              datalabel={item.label}
              datavalue={item.value}
              onClick={e => this.handleClick(e, item)}
              selected={selectedItem ? selectedItem.key === item.key : false}
              className={
                selectedItem && data.length === 1 ? "noBackSelection" : ""
              }
            >
              <ListItemText
                primary={<span style={{ fontWeight: 500 }}>{item.label}</span>}
              />
            </ListItem>
          );
        }
      });
    }
    return [];
  };

  async handleClick(event, item) {
    if (this.props.step.needContinue) {
      this.setState({ selectedItem: item, target: event.target });
    } else {
      const label = item.label;
      const value = event.target.value;
      const dataValue = item.value;
      const seq = item.sequence2;
      this.validateDataSelected(label, value, dataValue, seq);
    }
  }

  validateDataSelected(label, value, dataValue, sequence2 = "") {
    const returnedKey = this.props.step.returned.key;
    const returnedDataKey = this.props.step.returned.dataKey
      ? this.props.step.returned.dataKey
      : returnedKey;
    this.buildBreadcrumbs(label);
    if (returnedKey && value !== "") {
      if (sequence2) {
        this.props.getProtocol(sequence2, this.props.activeStep);
      } else {
        this.props.isValid(true);
      }
      this.props.setReturnedValue({
        [returnedKey]: value,
        [returnedDataKey]: dataValue
      });
    } else {
      this.props.isValid(false);
    }
  }

  buildBreadcrumbs = value => {
    const element = { textItem: value, stepItem: { ...this.props.activeStep } };
    this.props.setBreadcrumbs(element);
  };

  handleSubmit = () => {
    const { selectedItem, target } = this.state;
    const label = selectedItem.label;
    const value = target ? target.value : undefined;
    const dataValue = selectedItem.value;
    const seq = selectedItem.sequence2;
    this.validateDataSelected(label, value, dataValue, seq);
  };

  handleErrorClose = () => {
    this.props.setMessageWithCodeFunc("");
  };

  render() {
    const { step } = this.props;
    let data = this.getData();
    this.props.showFooterContinue({
      isShow: this.state.showBtnContinue,
      handler: this.handleSubmit,
      disabled: !this.state.selectedItem
    });
    return (
      <React.Fragment>
        {data && (
          <div className="multiple-select-custom">
            {this.props.typeConsultation === "teleconsult" ? (
              <>
                {step.returned.key !== "appointmentLocation" ? (
                  <>
                    <label className="label">
                      {step.icon && <img src={step.icon} alt={step.label} />}
                      &nbsp;
                      {step.label}
                      {this.props.typeConsultation === "teleconsult" && (
                        <VideocamIcon className="icon-video" />
                      )}
                    </label>
                    <MaterialList>{this.getRenderItem(data)}</MaterialList>
                  </>
                ) : (
                  <>
                    <label className="label">
                      {translator()._("W_MESSAGE_TELECONSULT")}
                    </label>
                  </>
                )}
              </>
            ) : (
              this.props.typeConsultation !== "teleconsult" && (
                <>
                  {step.returned.key === "practitioner" ? (
                    <>
                      <label className="label">
                        {step.icon && <img src={step.icon} alt={step.label} />}
                        &nbsp;
                        {step.label}
                      </label>
                      <MaterialList>
                        {this.getRenderItemPraticien(data)}
                      </MaterialList>
                    </>
                  ) : (
                    <>
                      <label className="label">
                        {step.icon && <img src={step.icon} alt={step.label} />}
                        &nbsp;
                        {step.label}
                      </label>
                      <MaterialList>{this.getRenderItem(data)}</MaterialList>
                    </>
                  )}
                </>
              )
            )}
            {step.showLinkPriorityCode &&
              this.props.isShowLinkPriorityCode &&
              this.props.isFromAdmin !== "admin" && <PriorityCode />}
          </div>
        )}
        {this.props.messageWithCode && this.props.messageWithCode.text && (
          <AlertDialog
            content={this.props.messageWithCode.text}
            onClick={this.handleErrorClose}
          />
        )}
      </React.Fragment>
    );
  }
}

List.propTypes = {
  activeStep: PropTypes.any,
  dataSource: PropTypes.any,
  fetchData: PropTypes.func,
  getProtocol: PropTypes.func,
  handleContinueFooter: PropTypes.func,
  isFromAdmin: PropTypes.string,
  isShowLinkPriorityCode: PropTypes.any,
  isValid: PropTypes.func,
  resetData: PropTypes.func,
  setBreadcrumbs: PropTypes.func,
  setReturnedValue: PropTypes.func,
  showFooterContinue: PropTypes.func,
  messageWithCode: PropTypes.shape({
    text: PropTypes.string,
    code: PropTypes.number
  }),
  step: PropTypes.shape({
    data: PropTypes.shape({
      fetchSource: PropTypes.func,
      formatSource: PropTypes.func,
      keyValue: PropTypes.any
    }),
    icon: PropTypes.any,
    label: PropTypes.any,
    needContinue: PropTypes.any,
    returned: PropTypes.shape({
      dataKey: PropTypes.any,
      key: PropTypes.any
    }),
    showLinkPriorityCode: PropTypes.any
  }),
  typeConsultation: PropTypes.string,
  setMessageWithCodeFunc: PropTypes.func
};

const mapStateToProps = state => {
  return {
    dataSource: state.dataSource,
    activeStep: state.activeStep,
    isShowLinkPriorityCode: state.configuration.baffcodeprioritaire,
    typeConsultation: state.returnedValue.typeConsultation,
    isFromAdmin: state.returnedValue.from,
    messageWithCode: state.messageWithCode
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchData: functionName => dispatch(functionName()),
    setReturnedValue: value => dispatch(setReturnedValue(value)),
    setBreadcrumbs: item => dispatch(setItemBreadcrumbs(item)),
    resetData: key => dispatch(addFieldData(key, null)),
    getProtocol: (url, activeStep) => dispatch(getProtocol(url, activeStep)),
    showFooterContinue: isShow => dispatch(showFooterContinue(isShow)),
    handleContinueFooter: handler => dispatch(handleContinueFooter(handler)),
    setMessageWithCodeFunc: message => dispatch(setMessageWithCode(message))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(List);
